import React, { useContext, useEffect, useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout ";
import "../../../assets/styles/admin/AdminSettings.css";
import axios from "axios";
import { responsivePropType } from "react-bootstrap/esm/createUtilityClasses";

import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

/* =============================================
   SECURITY TAB
   ============================================= */
const SecurityTab = () => {
  const [form, setForm] = useState({ current: "", newPass: "", confirm: "" });
  const [show, setShow] = useState({
    current: false,
    newPass: false,
    confirm: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [currentPass, setcurrentPass] = useState("");
  const [newPass, setnewPass] = useState("");
  const [confirmPass, setconfirmPass] = useState("");
  const [admin, setAdmin] = useState();

  const { baseUrl, loggedInAdmin } = useContext(AppContext);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  const toggleShow = (key) =>
    setShow((prev) => ({ ...prev, [key]: !prev[key] }));

  const changePassword = () => {
    console.log("change", currentPass, newPass, confirmPass);
    // console.log(admin);
    const admin = JSON.parse(localStorage.getItem("admin"));
    const formData = new FormData();
    formData.append("mwadmin_id", 2);
    // formData.append("mwadmin_id", admin.id);
    formData.append("currPass", currentPass);
    formData.append("newPass", newPass);
    // formData.append("confirmPass", confirmPass);
    // console.log("",response.data);

    axios
      .post(`${baseUrl}/admin/setting/changePassword`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("update response:", response.data);
        Swal.fire({
          title: "Updated",
          text: "Password changed successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
      })
      .catch((error) => {
        console.log("update error:", error);
        Swal.fire({
          title: "Error!",
          text: error?.response?.data?.message || "Could not update admin",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  useEffect(() => {
    
    setAdmin(JSON.parse(localStorage.getItem("admin")));
    console.log(JSON.parse(localStorage.getItem("admin")));

    // }
  }, []);


  return (
    <div className="adminSettings-card">
      <div className="adminSettings-card-header">
        <h4>Security Settings</h4>
        <p>Change your admin account password</p>
      </div>

      {error && (
        <div className="adminSettings-alert adminSettings-alert--error">
          {error}
        </div>
      )}
      {success && (
        <div className="adminSettings-alert adminSettings-alert--success">
          {success}
        </div>
      )}

      {/* {fields.map(({ key, label, placeholder }) => ( */}
      {/* <div className="adminSettings-field" key={"current"}>
          <label>{label}</label>
          <div className="adminSettings-input-wrap">
            <input
              className="adminSettings-input adminSettings-input--pass"
              name={key}
              type={show[key] ? "text" : "password"}
              placeholder={placeholder}
              value={form[key]}
              onChange={handleChange}
            />
            <button
              type="button"
              className="adminSettings-eye-btn"
              onClick={() => toggleShow(key)}
              tabIndex={-1}
            >
              {show[key] ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div> */}
      <div className="adminSettings-field" key={"current"}>
        <label>Current Password</label>
        <div className="adminSettings-input-wrap">
          <input
            className="adminSettings-input adminSettings-input--pass"
            // name={key}
            type={show["current"] ? "text" : "password"}
            placeholder="Current Password"
            value={currentPass}
            onChange={(e) => setcurrentPass(e.target.value)}
          />
          <button
            type="button"
            className="adminSettings-eye-btn"
            onClick={() => toggleShow("current")}
            tabIndex={-1}
          >
            {show["current"] ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
      </div>
      <div className="adminSettings-field" key={"newPass"}>
        <label>New Password</label>
        <div className="adminSettings-input-wrap">
          <input
            className="adminSettings-input adminSettings-input--pass"
            // name={key}
            type={show["newPass"] ? "text" : "password"}
            placeholder="New Password"
            value={newPass}
            onChange={(e) => setnewPass(e.target.value)}
          />
          <button
            type="button"
            className="adminSettings-eye-btn"
            onClick={() => toggleShow("newPass")}
            tabIndex={-1}
          >
            {show["newPass"] ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
      </div>
      <div className="adminSettings-field" key={"confirm"}>
        <label>Confirm New Password</label>
        <div className="adminSettings-input-wrap">
          <input
            className="adminSettings-input adminSettings-input--pass"
            // name={key}
            type={show["confirm"] ? "text" : "password"}
            placeholder="Confirm New Password"
            value={confirmPass}
            onChange={(e) => setconfirmPass(e.target.value)}
          />
          <button
            type="button"
            className="adminSettings-eye-btn"
            onClick={() => toggleShow("confirm")}
            tabIndex={-1}
          >
            {show["confirm"] ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
      </div>
      {/* ))} */}

      <button
        className="adminSettings-save-btn"
        onClick={changePassword}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update Password"}
      </button>
    </div>
  );
};

/* =============================================
   MAIN COMPONENT
   ============================================= */
const AdminSettings = () => {
  return (
    <AdminMasterLayout>
      <div className="adminSettings-page">
        <div className="adminSettings-header">
          <h2>Security Settings</h2>
          <p>Manage your account password</p>
        </div>
        <SecurityTab />
      </div>
    </AdminMasterLayout>
  );
};

export default AdminSettings;
